import { render } from "./RuiNotify.vue?vue&type=template&id=2c5655ad&scoped=true"
import script from "./RuiNotify.vue?vue&type=script&lang=ts"
export * from "./RuiNotify.vue?vue&type=script&lang=ts"

import "./RuiNotify.vue?vue&type=style&index=0&id=2c5655ad&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2c5655ad"

export default script